// src/utils/url.js

// 正式
export const baseURL = 'https://admin.gaobaoaiedu.com'
// 测试
// export const baseURL = 'https://kysx.400539.com'
